export default "__VITE_ASSET__Dp6r$4qV__"